'use strict';
// Please don't chnage any regex expression without verifying all the scenarios specially related to PLCC functionality
var naPhone = /^\(?([2-9][0-9][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
var regex = {
    phone: {
        us: naPhone,
        ca: naPhone,
        fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
        it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
        jp: /^(0\d{1,4}- ?)?\d{1,4}-\d{4}$/,
        cn: /.*/,
        gb: /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/
    },
    postal: {
        us: /^\d{5}(-\d{4})?$/,
        ca: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
        fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
        it: /^([0-9]){5}$/,
        jp: /^([0-9]){3}[-]([0-9]){4}$/,
        cn: /^([0-9]){6}$/,
        gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/
    },
    password: /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{8,16}$/,
    notCC: /^(?!(([0-9 -]){13,19})).*$/,
    alpaNumaric: /^[0-9*]+$/,
    ssn: /^((\d{3}-?\d{2}-?\d{4})|(X{3}-?X{2}-?X{4}))$/,
    email : /^([\w\.\-\+])+\@(((\w[\-\w]*\.)+([a-zA-Z]{2,6}))|(\[{0,1}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\]{0,1}))$/,
    owner : /^$|^(?=.*\S?[a-zA-Z])[^\<\>\~\!\@\#\%\&\=\[\\\^\$\|\?\*\+\(\)\]]+$/,
    city  : /^$|^(?=.*\S?[a-zA-Z])[^\<\>\~\!\@\#\%\&\=\[\\\^\$\|\?\*\+\(\)\]]+$/,
	nickname: /^$|^(?=.*\S?[a-zA-Z])[^\/\.\<\>\~\!\@\#\%\&\=\[\\\^\$\|\?\*\:\+\(\)\]]+$/,
    preapprovedssn : /^[0-9]{4}$/,
	cvvno : /[^0-9*]/g,
	anyDigitOrDash: /^[0-9-]{9,15}$/,
    digitAndHyphen: /^[0-9]{1,4}-[0-9]{5}-[0-9]{3,4}|^[0-9]{9,13}$/,
	allsamechar : /^(.)\1+$/,
	coupon: /^[A-Za-z0-9-]+$/,
	plcc : /^[0-9*]{8,16}$/,
	ccNumber: /^[0-9*]{13,19}$/,
	digitsLettersAndDashes: /^([A-Za-z0-9\-\_]+)$/,
	website: /^(http[s]?:\/\/){0,1}([a-zA-Z0-9\-]{1,255}\.)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|][^\s]\1*$/

};
// global form validator settings
var settings = {
    errorClass: 'error',
    errorElement: 'span',
    onkeyup: false,
    onfocusout: function (element) {
    	
        if( $(element).is(':input') && $(element).val() == "" && (!$(element).hasClass("email") && !$(element).closest('.form-row').hasClass("username") && !$(element).closest('.form-row').hasClass("username") && !$(element).closest(".right-panel-pane-login").length) && (!$(element).hasClass("password") || ($(element).hasClass("password") && $(element).closest(".login-form").length)) && !$(element).hasClass("newpassword") && !$(element).hasClass("newpasswordconfirm") && !$(element).hasClass("confirmpassword") && !$(element).is('[id*=singleshipping_shippingAddress_addressFields]') && !$(element).is('[id*=billing_billingAddress_addressFields]') && !$(element).is('[id*=billing_paymentMethods_creditCard]') || ( $(element).hasClass("validateDOB") && !enteredFullDOB( $(element).closest('.form-row-dob') ) ) ){
        	if($(element).closest('.form-row').hasClass("show-text") && !($(element).closest('fieldset').parent().hasClass('plcc-form-row-1') || $(element).closest('fieldset').parent().hasClass('plcc-form-row-2'))){
                  $(element).closest('.form-row').removeClass("show-text");
        }
        	return false;   // don't show error onfocusout if the user hasn't entered anything in this field, or if the user selected a DOB value but hasn't yet entered all 3 (day,month,year)
        }
            
        if (!this.checkable(element)) {
        	var $curFormRow = $(element).closest(".form-row");
    		var $curLabel = $curFormRow.find("label");
        	$curLabel.find(".server-error").remove();
        	if($curLabel.find('.label-text').hasClass('error') && $('#wrapper').hasClass('quick-order-page')) {
        		return true;
        	} else {
        		this.element(element);
        	}
        }
    },
    highlight: function( element, errorClass, validClass ) {
		if ( element.type === "radio" ) {
			this.findByName( element.name ).addClass( errorClass ).removeClass( validClass );
		} else {
			$( element ).addClass( errorClass ).removeClass( validClass );
		}
		if( $(element).closest(".make-label-absolute").length > 0 ) {
			var $curFormRow = $(element).closest(".form-row");
			var $curLabel = $curFormRow.find("label");

			if($(element).hasClass("error")) {
				$curFormRow.addClass("error-handle");
				if(!$curFormRow.find('.custom-select').length) {
					$curFormRow.removeClass("show-text");
				}
	    	} else {
	    		$curFormRow.removeClass("error-handle");
				if(!$curFormRow.find('.custom-select').length) {
					$curFormRow.addClass("show-text");
				}
	    	}

			// shows DOB error if month day and year have all been selected
			if( $(element).hasClass("validateDOB") && (enteredFullDOB($('.form-row-dob')) || $(element).hasClass("plcc-birthdate-full")) ) {
				$('.invalid-date').removeClass('hide');
				var dobFlag = true;
				$(element).closest(".form-row-dob").find(".check-rel-dates").each(function(){
					var curValue = $(this).val();
					if( curValue.length == 0 ){
						dobFlag = false;
					}
				});
				if( $(element).val() != "" && dobFlag) {
					$(element).closest(".form-row-dob").find(".form-row").removeClass("error-handle").addClass("show-text");
					$('.birth-month,.birth-date,.birth-year').addClass('error');
				} else if ($(element).val() != "") {
    				$(element).closest(".form-row").removeClass("error-handle").addClass("show-text");
    			}
			}
			//validate field for password for error flags in case of empty
			if(($(element).hasClass("password") || $(element).hasClass("newpassword")) && $(element).val() == ""){
				validatePassword($(element).val(),$(element));
			}
			
			//validate field for confirm password password for error flags in case of empty
			if(($(element).hasClass("newpasswordconfirm") || $(element).hasClass("confirmpassword")) && $(element).val() == ""){
				validateConfirmPassword($(element).val(),$(element));
			}
		}
	},
	unhighlight: function( element, errorClass, validClass ) {
		if ( element.type === "radio" ) {
			this.findByName( element.name ).removeClass( errorClass ).addClass( validClass );
		} else {
			$( element ).removeClass( errorClass ).addClass( validClass );
		}
		if( $(element).closest(".make-label-absolute").length > 0 ) {
			var $curFormRow = $(element).closest(".form-row");
			var $curLabel = $curFormRow.find("label");

			if($(element).hasClass("error")) {
				$curFormRow.removeClass("show-text").addClass("error-handle");
	    	} else {
	    		if($(element).val() != ""){
	    			$curFormRow.removeClass("error-handle").addClass("show-text");
	    		}else{
	    			$curFormRow.removeClass("error-handle");
	    		}
	    		
	    	}
			if($(element).hasClass("validateDOB")) {
				$('.invalid-date').addClass('hide');
				var dobFlag = true;
				$(element).closest(".form-row-dob").find(".check-rel-dates").each(function(){
					var curValue = $(this).val();
					if( curValue.length == 0 ){
						dobFlag = false;
					}
				});
				if( $(element).val() != "" && dobFlag) {
					$(element).closest(".form-row-dob").find(".form-row").removeClass("error-handle").addClass("show-text");
					$('.birth-month,.birth-date,.birth-year').removeClass('error');
				} else if ($(element).val() != "") {
    				$(element).closest(".form-row").removeClass("error-handle").addClass("show-text");
    			}
			}
		}
	},
    errorPlacement: function(error, element) {
    	if( $(element).closest(".make-label-absolute").length > 0 ) {
    		var $curFormRow = $(element).closest(".form-row");
    		var $curLabel = $curFormRow.find("label");
			$curLabel.find(".server-error").remove();
    		$curLabel.prepend(error);

			if($curLabel.find(".error").is(":visible")) {
    			$curFormRow.removeClass("show-text field-valid").addClass("error-handle");
        	} else {
        		if($(element).val() == "" && $(element).hasClass("valid")) {
        			$curFormRow.removeClass("error-handle field-valid").addClass("show-text field-valid");
        		} else {
        			$curFormRow.removeClass("error-handle field-valid").addClass("show-text");
        		}

        	}

        	// shows DOB error if month day and year have all been selected
    		if( $(element).hasClass("validateDOB") && enteredFullDOB($('.form-row-dob')) && $(element).hasClass("error") ) {
    			$('.invalid-date').removeClass('hide');
    			var dobFlag = true;
				$(element).closest(".form-row-dob").find(".check-rel-dates").each(function(){
					var curValue = $(this).val();
					if( curValue.length == 0 ){
						dobFlag = false;
					}
				});
				if( $(element).val() != "" && dobFlag) {
    				$(element).closest(".form-row-dob").find(".form-row").removeClass("error-handle").addClass("show-text");
    				$('.birth-month,.birth-date,.birth-year').addClass('error');
    			} else if ($(element).val() != "") {
    				$(element).closest(".form-row").removeClass("error-handle").addClass("show-text");
    			}

    		}
    	} else {
    		$(element).after(error);
    	}

	},
	errorClear: function( element) {
    	if( $(element).closest(".make-label-absolute").length > 0 ) {
    		var $curFormRow = $(element).closest(".form-row");
    		var $curLabelServerError = $curFormRow.find("label").find(".server-error");
    		var $curErrorLabel = $curFormRow.find("label").find(".error");

    		if($curLabelServerError.length){
    			$curLabelServerError.remove();
    			$curFormRow.removeClass("error-handle");
				$(element).removeClass('error');
    		}

			if($curErrorLabel.is(":visible")) {
				$curFormRow.removeClass("error-handle");
				$(element).removeClass('error');
				$curErrorLabel.hide();
        	}
    	}
    }
};

/**
 * @function
 * @description Returns true when user has selected all DOB values (month,day,year)
 * @param {String} el jQuery element containing all DOB select elements
 */
var enteredFullDOB = function (el) {
	return (el.find('.plcc-birthdate-full').length && el.find('.plcc-birthdate-full').val() !== "") || (!!el.find('.month select').val() && !!el.find('.day select').val() && !!el.find('.year select').val());
}

/**
 * @function
 * @description Validates a given date given a day, month, and year
 * @param {String} day The day portion of the date
 * @param {String} month The month portion of the date
 * @param {String} year The year portion of the date
 */
var isValidDate = function (day, month, year) {
  day = Number(day);
  month = Number(month);
  year = Number(year);

  var date = new Date();
  date.setFullYear(year, month - 1, day);
  // month - 1 since the month index is 0-based (0 = January)
  if ( (date.getFullYear() == year) && (date.getMonth() == month - 1) && (date.getDate() == day) ) {
    return true;
  }

  return false;
}

/**
 * @function
 * @description Helper function for validator that checks if a whole string is a consective array of digits
 * @param {String} str The string to be checked
 */
var stringIsConsecutiveDigits = function (str) {
    if(str.length == 1 || isNaN(Number(str))){
        // the string is too short or Not a Number
        return false;
    }

    // make sure digits are descending for easier processing. we only have to check the first two digits.
    if(Number(str[0]) < Number(str[1]))
        str = str.split('').reverse().join('');

    for(var i=0;i<str.length-1;i++) {
        if(Number(str[i]) - Number(str[i+1]) != 1) {
            // two successive digits aren't consecutive
            return false;
        }
    }

    // all digits are consecutive
    return true;
};
/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function (value, el) {
	var rgx = regex.phone['us'];
    var isValid = rgx.test($.trim(value));
    isValid = isValid && !regex.allsamechar.test($.trim(value));    // checks that all characters aren't the same
    isValid = isValid && !stringIsConsecutiveDigits($.trim(value)); // checks that value isn't consecutive digits

    /*PXSFCC-5551 - Please don't change if else conditions. If you have to change, then please verify phone number validation
    	on shipping/billing address and combination of phone number & alternate phone number on web instant, prescreen accept and preapproved pages.
    */
    if($('.personal-info').length > 0){
		if(value.length == 0) {
			return true;
		} else{
			return isValid;
		}
	}
    if (isValid) {
        if($(el).hasClass('alternativePhone') && value.length == 0) {
            return true;
        } else if($(el).closest("form").hasClass("plcc_preapproved_application_form") || $(el).closest("form").hasClass("plcc_web_application_form")){
            if($(el).hasClass('phone') && value.length == 0) {
                return true;
            }
        }
    } else if($(el).hasClass('alternativePhone') && value.length == 0) {
        return true;
    } else if($(el).closest("form").hasClass("plcc_preapproved_application_form") || $(el).closest("form").hasClass("plcc_web_application_form")){
        if($(el).hasClass('phone') && value.length == 0) {
            return true;
        }
    }

    return isValid;
};
function validateEmail(value, el) {
	var formcaption=$(el).closest('.form-row').find('.form-caption.error-message'),
		formValid = $(el).closest('.form-row').find('.input-text');
	if(formcaption.length > 0){
		$(el).closest('.form-row').find('.form-caption.error-message').remove();
	}
	var isOptional = this.optional(el);
    var isValid = regex.email.test($.trim(value));
    if(isValid){
		$(el).closest('.form-row').removeClass('error');
		if($(el).hasClass('resetemail') || $(el).closest('.form-row').hasClass('username')){
			if(!$(el).hasClass('email-login-failure')){
				$(el).closest('.form-row').siblings('.reset-error-caption:not(.password-req)').addClass('hide');
			}else{
				$(el).closest('.form-row').siblings('.reset-error-caption:not(.password-req,.invalid-email)').addClass('hide');
			}
		}
	}else{
		if($(el).hasClass('resetemail') || $(el).closest('.form-row').hasClass('username')){
			$(el).closest('.form-row').siblings('.reset-error-caption').not('.invalid-email,.passwordError').removeClass('hide');
			if(value.length){				
				$(el).closest('.form-row').siblings('.reset-error-caption.email-valid').removeClass('hide');
				$(el).closest('.form-row').siblings('.reset-error-caption.username-req').addClass('hide');
		        $(el).closest('.form-row').siblings('.reset-error-caption.email-valid').attr('id', 'email_error');
				$(el).closest('.form-row').siblings('.reset-error-caption.username-req').attr('id', 'email_error_na');
			}else{
				$(el).closest('.form-row').siblings('.reset-error-caption.email-valid').addClass('hide');
				$(el).closest('.form-row').siblings('.reset-error-caption.username-req').removeClass('hide');
			}
			if(!$(el).hasClass('email-login-failure')){
				$(el).closest('.form-row').siblings('.reset-error-caption.invalid-email').addClass('hide');
			}
		}
	}
    return isOptional || isValid;
}

function validateConfirmEmail(value, el) {
	var email = $(el).closest('form').find('input.email');
	if($(email).val().toLowerCase() == $(el).val().toLowerCase()) {
		$(el).closest('.form-row').removeClass('error');
		return true;
	}else {
		return false;
	}
}

function validateConfirmPassword(value, el) {
	var password = $(el).closest('form').find('input.password').not('.currentpassword');
	if($(password).val() == null || $(password).val() == '' || $(el).val() == null || $(el).val() == ''){
		return true;
	}
	if($(password).val() == $(el).val()) {
		return true;
	}else {
		$(el).closest('.form-row').next('.password-status').find('.match-check').removeClass('default');
		$(el).closest('.form-row').next('.password-status').find('.match-check').removeClass('success');
		$(el).closest('.form-row').next('.password-status').find('.match-check').addClass('fail');
		return false;
	}
}

function validateCVN(value, el) {
	var type = $('.billingfields .type select').val();
	var cvn = $(el).val();
	if (type != undefined && type != null && type != '' && cvn != null && cvn != '') {
		if(!(regex.cvvno.test($.trim(value)))) {
			if(type != "Amex" && cvn.length != 3) {
				return false;
			} else if(type == "Amex" && cvn.length != 4) {
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	} else {
		return true;
	}
}

/**
 * @function
 * @description Validates that length of PLCC is min 8 digits
 */
function validateCreditCard(value, el) {
	var type = $('.billingfields .type select').val(),
	cardTypePlcc = $('.billingfields .type select option[value="'+type+'"]').attr('plcctype'),
	cardNo = $(el).val();
	if (type != undefined && type != null && type != '' && cardTypePlcc === 'true' && cardNo != null && cardNo != '') {
		var isValid = regex.plcc.test(value);
	    return isValid;
	} else if(type != undefined && type != null && type != '' && cardTypePlcc === 'false' && cardNo != null && cardNo != ''){
		var isValid = regex.ccNumber.test(value);
	    return isValid;
	} else {
		return true;
	}
}

function validateEmailField(value) {
	var regex = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	return (regex.test(value)) ? true : false;
}

function validateMultipleEmails(value, el) {
	var result = value.split(/[,]+/);

	for(var i = 0; i < result.length; i++){
		if(!validateEmailField(result[i])) {
			return false;
	    }
	}
    return true;
}

/**
 * @function
 * @description Validates that a name is valid
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function (value) {
	var isValid = regex.owner.test(value);
    return isValid;
};
/**
 * @function
 * @description Validates that a name is valid
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateField = function (value,el) {
	if (value != null && value != '' && !value.replace(/\s/g, '').length) {
		return false;
    }
    $(el).closest('.form-row').removeClass('error');
    return true;
};

var validateNickName = function (value,el){
		var isValid = regex.nickname.test(value);
		return isValid;
};

/**
 * @function
 * @description Validates that a city is valid
 * @param {String} value The city field which will be validated
 * @param {String} el The input field
 */
var validateCity = function (value) {
    var isValid = regex.city.test(value);
    return isValid;
};

/**
 * @function
 * @description Validates that a website url mentioned in marketplace seller form is valid 
 * @param {String} value The website url field which will be validated
 * @param {String} el The input field
 */
var validateWebsiteUrl = function (value) {
	var isValid = regex.website.test(value);
    return isValid;
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validatePostal = function (value, el) {

	var country = $(el).closest('form').find('select.country');
    var countryVal;

	if (country.length === 0 || country.val() === null) {
		countryVal = 'us';
    } else {
    	countryVal = country.val().toLowerCase();
    }

    var rgx = regex.postal[countryVal];
    var isOptional = this.optional(el);
    var isValid = rgx.test($.trim(value));

    return isOptional || isValid;
};

/**
 * @function
 * @description Validates that a Password contains Number and Character
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validatePassword = function (value, el) {
	var isValid;
	var pwdCheckElements=$(el).closest('.form-row').next('.password-status');
	var errCounter=$(el).data('validation-counter');	
	if(!$(el).hasClass('confirmpassword') && !$(el).hasClass('newpasswordconfirm')) {
		if (value == '' && $('body').find('.registrationType').length && $('body').find('.registrationType').val() == 'optional') {
			isValid= true;
		} else if ((value != null &&  value != '') || (value == '' && !$(el).hasClass("no-pwd-validate"))) {
			if($(el).hasClass("no-pwd-validate")){
				if(!$(el).hasClass("email-login-failure")){
					$(el).closest('.form-row').siblings('.reset-error-caption.invalid-email').addClass('hide');
				}								
				isValid=true;					
			}else{
				var rgx = regex.password;
				isValid = rgx.test($.trim(value));
				var letters = /[a-z]/i;
				var numbers= /\d/;
				var isContainsNumber=numbers.test(value);			
				var isContainsChar= letters.test(value);
				if(!$(el).hasClass("currentpassword")){
					if(!isContainsNumber){
						pwdCheckElements.find('.number-check').removeClass('default');
						pwdCheckElements.find('.number-check').removeClass('success');
						pwdCheckElements.find('.number-check').addClass('fail');	
					}
					if(!isContainsChar){
						pwdCheckElements.find('.letter-check').removeClass('default');
						pwdCheckElements.find('.letter-check').removeClass('success');
						pwdCheckElements.find('.letter-check').addClass('fail');
					}
					if(value.length < 8) {
						pwdCheckElements.find('.length-check').removeClass('default');
						pwdCheckElements.find('.length-check').removeClass('success');		
						pwdCheckElements.find('.length-check').addClass('fail');
					}
					if(value.length < 8 || !isContainsNumber || !isContainsChar){
						if($('.password').hasClass('order-confirmation')){
							pwdCheckElements.hide();
							$(el).closest('.form-row').find('.form-caption').show();							
							$(el).closest('.form-row').find('.form-caption').attr({"aria-live":"assertive", id:"pwd-error"});
						}else{
							if(errCounter == null || errCounter== '' || errCounter== undefined || errCounter=='0'){
								$(el).data('validation-counter',"1");
							}else{
								errCounter=parseInt(errCounter);
								errCounter+=1
								$(el).data('validation-counter',errCounter);				
								if(errCounter>=4){
									pwdCheckElements.hide();
									$(el).closest('.form-row').find('.form-caption').show();							
								}									
							}
						}
					}
				}
			}			
		}else{
			isValid= true;
			if($(el).hasClass("no-pwd-validate")){
				isValid=false;
			}
		}
	}else{
		isValid= true;
	}
	return isValid;
};
/**
 * @function
 * @description Validates the password length
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validatePwdLength = function (value, el) {
	var isValid;
	if (value != null && value != '' &&( value.length < 8 || value.length >16)) {
		isValid = false;
	} else {
		isValid = true;
	}
	

	return isValid;
};


/**
 * @function
 * @description Validates the SSN of customer
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateSSN = function (value, el) {
    var isValid;
    var isOptional = this.optional(el);
    value = $("input.ssn").unmask().val();
    isValid = regex.ssn.test($.trim(value));
    isValid = isValid && !regex.allsamechar.test($.trim(value));    // checks that all characters aren't the same
    isValid = isValid && !stringIsConsecutiveDigits($.trim(value)); // checks that value isn't consecutive digits
    $('input.ssn').unmask().maskSSN('999-99-9999', {maskedChar:'X', maskedCharsLength:5, numericMaskedCharEquivalent:'9'});
    return isOptional || isValid;
};
/**
 * @function
 * @description Validates the SSN for pre approved customer
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validatePreApprovedSSN = function (value, el) {
	var isValid;
	var isOptional = this.optional(el);
	isValid = regex.preapprovedssn.test($.trim(value));
	return isOptional || isValid;
};

/**
 * @function
 * @description Validates that a gift card Pin number is not a pin card number
 */
var validateGiftPinNumber = function (value, el) {
	var isValid = false;
	if(value.length < 4) {
		isValid = false;
	} else {
		isValid = true;
	}
    return isValid;

};
/**
 * @function
 * @description Validates that a gift card Pin number is not a pin card number
 */
var validateGiftCardNumber = function (value, el) {
	var isValid = false;
	if(value.length < 16) {
		isValid = false;
	} else {
		isValid = true;
	}
    return isValid;

};
/**
 * @function
 * @description Validates that a Credit Card number
 */
var validateOnlyNumber = function (value, el) {
    var isOptional = this.optional(el);
	//var isValid = regex.alpaNumaric.test($.trim(value));
	var isValid = regex.digitsLettersAndDashes.test($.trim(value));
    return isOptional || isValid;
};
/**
 * @function
 * @description Validates that a given DOB is a real date
 */
var validateDOB = function( value, element ) {
	var $dobBlock = $(element).closest(".form-row-dob");
	var date = $dobBlock.find(".birth-date").val();
	var month = $dobBlock.find(".birth-month").val();
	var year = $dobBlock.find(".birth-year").val();
	var fullBirthdateEl = $dobBlock.find(".birthdate.plcc-birthdate-full");
	var isSingleInput = !!fullBirthdateEl.length;
	var curDate = new Date();
	var isValidDateBool = false;

	if(((!date || !month || !year) && !isSingleInput) || (isSingleInput && (!fullBirthdateEl.val() || fullBirthdateEl.val().length !== 10))) {
		return false;
	}

	if (isSingleInput) {
		var birthdateVal = fullBirthdateEl.val();
		var newDate = new Date(birthdateVal);
		var splitDate = birthdateVal.split('/');
		isValidDateBool = isValidDate(splitDate[1], splitDate[0], splitDate[2]);
	} else {
		date = Number(date);
		month = Number(month);
		year = Number(year);
		
		var newDate = new Date();
		newDate.setFullYear(year, month - 1, date);
		isValidDateBool = isValidDate(date, month, year);
	}
	
	return this.optional(element) == true || ( isValidDateBool && newDate <= curDate );
};

$.validator.addMethod('validateDOB', validateDOB, "");
/**
 * @function
 * @description Validates CQO Fields have only Digits and Hyphen
 */
var validateCQODigitAndHyphen = function (value, el) {
    var isOptional = this.optional(el);
	var isValid = regex.digitAndHyphen.test($.trim(value));
	return isOptional || isValid;
}

/**
* @function
* @description Validates CQO Fields have only Digits and Hyphen, but dashs can be anywhere
*/

var validateCQOAnyDigitOrDash = function validateCQOAnyDigitOrDash(value, el) {
	var isOptional = this.optional(el);
	var isValid = regex.anyDigitOrDash.test($.trim(value));
	return isOptional || isValid;
   };

/**
 * @function
 * @description Validates that field only contains letters and numbers
 * @param {String} value The field which will be validated
 * @param {String} el The input field
 */
var validateLetterNumber = function (value, el) {
    var isOptional = this.optional(el);
    var isValid = regex.coupon.test($.trim(value));
    return isOptional || isValid;
};

$.validator.addMethod('coupon-code', validateLetterNumber, '');
$.validator.addMethod('reward-code', validateLetterNumber, '');
$.validator.addMethod('cvn', validateCVN, Resources.INVALID_CVN);

//$.validator.addMethod('cqo-digit-and-hyphen', validateCQODigitAndHyphen, Resources.VALIDATE_CQO_NUMBER);
$.validator.addMethod('cqo-digit-and-hyphen', validateCQOAnyDigitOrDash, Resources.VALIDATE_CQO_NUMBER);

$.validator.addMethod('pin-number', validateGiftPinNumber, Resources.INVALID_GIFTCARD_PIN);

$.validator.addMethod('currentpassword', validatePassword, Resources.INVALID_PASSWORD);
$.validator.addMethod('newpassword', validatePassword, Resources.NEW_PASSWORD);
$.validator.addMethod('password', validatePassword, Resources.PASSWORD);

$.validator.addMethod('passwordlength', validatePwdLength, Resources.INVALID_PASSWORD_LENGTH);

$.validator.addMethod('nickName', validateField, Resources.INVALID_NICKNAME);
$.validator.addMethod('address1', validateField, Resources.INVALID_ADDRESS1);
$.validator.addMethod('card-number', validateGiftCardNumber, Resources.INVALID_GIFTCARD_NUMBER);
/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' or 'alternativePhone' css class to be validated as phone
 */
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);
$.validator.addMethod('alternativePhone', validatePhone, Resources.INVALID_PHONE);
$.validator.addMethod('creditcardnumber', validateCreditCard, Resources.INVALID_CREDITCARD);
$.validator.addMethod('validate-order-number', validateOnlyNumber, Resources.VALIDATE_ORDER_NUMBER);

$.validator.addMethod('email', validateEmail, Resources.VALIDATE_EMAIL);
$.validator.addMethod('email_wishlist', validateEmail, Resources.VALIDATE_EMAIL_ERROR);
$.validator.addMethod('resetemail', validateEmail, Resources.EMAIL_LABEL);
$.validator.addMethod('confirmemail', validateConfirmEmail, Resources.VALIDATE_CONFIRMEMAIL);
$.validator.addMethod('newpasswordconfirm', validateConfirmPassword, Resources.NEWCONFIRMPASSWORD);
$.validator.addMethod('confirmpassword', validateConfirmPassword, Resources.CONFIRMPASSWORD);
$.validator.addMethod('multipleemails', validateMultipleEmails, Resources.VALIDATE_MULTIPLEEMAILS);
$.validator.addMethod('ssn', validateSSN, Resources.VALIDATE_SSN);
$.validator.addMethod('preapprovedssn', validatePreApprovedSSN, Resources.VALIDATE_SSN);

/**
 * Add name validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 * Added first and last name in both casing styles because some forms use camel casing naming and some use lower case.
 */
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);
$.validator.addMethod('firstName', validateOwner, Resources.INVALID_FIRSTNAME);
$.validator.addMethod('lastName', validateOwner, Resources.INVALID_LASTNAME);
$.validator.addMethod('firstname', validateOwner, Resources.INVALID_FIRSTNAME);
$.validator.addMethod('firstname_wishlist', validateOwner, Resources.INVALID_FIRSTNAME_ERROR);
$.validator.addMethod('lastname', validateOwner, Resources.INVALID_LASTNAME);
$.validator.addMethod('lastname_wishlist', validateOwner, Resources.INVALID_LASTNAME_ERROR);
$.validator.addMethod('city', validateCity, Resources.INVALID_CITY);
$.validator.addMethod('address1', validateOwner, Resources.INVALID_ADDRESS);
$.validator.addMethod('address2', validateOwner, Resources.INVALID_ADDRESS);
$.validator.addMethod('addressid', validateNickName, Resources.INVALID_NICKNAME);
$.validator.addMethod('nickName', validateOwner, Resources.INVALID_NICKNAME);

$.validator.addMethod('recipient', validateField);
$.validator.addMethod('from', validateField);
$.validator.addMethod('message', validateField, Resources.INVALID_MESSAGE);
/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('postal', validatePostal, Resources.INVALID_ZIP_SHORT);
$.validator.addMethod('validateWebsiteUrl', validateWebsiteUrl, Resources.INVALID_WEBSITE);
/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod('gift-cert-amount', function (value, el) {
    var isOptional = this.optional(el);
    var isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
    return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod('positivenumber', function (value) {
    if ($.trim(value).length === 0) { return true; }
    return (!isNaN(value) && Number(value) >= 0);
}, ''); // '' should be replaced with error message if needed

$.validator.messages.required = function ($1, ele, $3) {
	var requiredText;
	if($(ele).is('[id*=singleshipping_shippingAddress_addressFields]:not(.postal,.input-select)') || $(ele).is('[id*=billing_billingAddress_addressFields]:not(.postal,.input-select)') || $(ele).is('[id*=billing_paymentMethods_creditCard]:not(.input-select,.cvn)')){
		if($(ele).is('[id*=owner]')){
			requiredText = " " + $(ele).attr('data-required-text');
		}else{
		requiredText = " " + $(ele).attr('data-required-text');
		}
	}
	else{
		requiredText = $(ele).attr('data-required-text');
	    if(requiredText == undefined) {
	    	requiredText = Resources.VALIDATE_REQUIRED;
	    }
	}
    return requiredText||"";
};
$.validator.messages.email = function ($1, ele, $3) {
    var requiredText = $(ele).attr('email-invalid-text');
    if(requiredText == undefined) {
    	requiredText = Resources.VALIDATE_EMAIL;
    }
    return requiredText||"";
};
$.extend($.validator.messages, {
    //required: Resources.VALIDATE_REQUIRED,
    remote: Resources.VALIDATE_REMOTE,
    //email: Resources.VALIDATE_EMAIL,
    url: Resources.VALIDATE_URL,
    date: Resources.VALIDATE_DATE,
    dateISO: Resources.VALIDATE_DATEISO,
    number: Resources.VALIDATE_NUMBER,
    digits: Resources.VALIDATE_DIGITS,
    creditcard: Resources.VALIDATE_CREDITCARD,
    equalTo: Resources.VALIDATE_EQUALTO,
    //maxlength: $.validator.format(Resources.VALIDATE_MAXLENGTH),
    //minlength: $.validator.format(Resources.VALIDATE_MINLENGTH),
    rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
    range: $.validator.format(Resources.VALIDATE_RANGE),
    max: $.validator.format(Resources.VALIDATE_MAX),
    min: $.validator.format(Resources.VALIDATE_MIN)
});

var validator = {
    regex: regex,
    settings: settings,
    init: function () {
        var self = this;
        $('form:not(.suppress)').each(function () {
            $(this).validate(self.settings);
        });
    },
    initForm: function (f) {
        $(f).validate(this.settings);
    }
};

module.exports = validator;